import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL, HRMS_FINANCE_API_URL, HRMS_LMS_API_URL } from "../../../../Constants/baseConstant";
import { getUserData, getUserId } from "../../../Base/helper/baseFunctions";

//Employee
export const AddEmployeeStagetoMainHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/employee/addEmployeeStagetoMain`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
export const GetEmployeeStageHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/employee/getEmployeeStage`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}

export const UpdateEmployeeStageHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/employee/updateEmployeeStage`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            stage_employee_id: params?.stage_employee_id,
            employee_details: params?.employee_details
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}

export const DeleteEmployeeStageHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/employee/deleteEmployeeStage`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: data.domain,
            user_id: getUserId(),
            stage_employee_id: params?.stage_employee_id,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed to delete", hasError: false, data: err?.response?.data }
        })
}

//PAYROLL Bulk helpers

export const AddPayrollStagetoMainHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/finance/addPayrollStagetoMain`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
export const GetPayrollStageHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/finance/getPayrollStage`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}

export const UpdatePayrollStageHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/updatePayrollStage`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            stage_payroll_id: params?.stage_payroll_id,
            payroll_details: params?.payroll_details
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}

export const DeletePayrollStageHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/finance/deletePayrollStage`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data.domain,
            user_id: getUserId(),
            stage_payroll_id: params?.stage_payroll_id,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed to delete", hasError: false, data: err?.response?.data }
        })
}

export const BulkUploadCalculateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/BulkUploadCalculate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: false, data: err?.response?.data }
        })
}
export const BulkUploadCalculateAdvanceHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/BulkUploadAdvanceCalculate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: false, data: err?.response?.data }
        })
}


export const BulkUploadCUContractualHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/BulkUploadContractualCalUpsert`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: false, data: err?.response?.data }
        })
}
export const BulkUploadCUContractualPayableDaysHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/BulkUploadContractualPayableDaysCalUpsert`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: false, data: err?.response?.data }
        })
}
export const BulkUploadCUContractualDailyHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/BulkUploadContractualDailyCalUpsert`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: false, data: err?.response?.data }
        })
}

export const BulkUploadCalculateMonthlyCtcHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/BulkUploadAdvanceCalculateMonthlyCtc`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: false, data: err?.response?.data }
        })
}
//LMS

export const GetLeaveBalanceStageHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/lms/getLeaveBalanceStage`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: data?.employee_id,
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}

export const UpdateLeaveBalanceStageHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/lms/updateLeaveBalanceStage`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: data?.employee_id,
            stage_leave_balance_id: params?.stage_leave_balance_id,
            leave_balance_details: params?.leave_balance_details
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}

export const DeleteLeaveBalanceStageHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/deleteLeaveBalanceStage`, {
        method: "DELETE",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            user_id: data.employee_id,
            stage_leave_balance_id: params?.stage_leave_balance_id,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed to delete", hasError: false, data: err?.response?.data }
        })
}


//Bio Metric
export const AddBioMetricDataStagetoMainHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/lms/addBioMetricDataStagetoMain`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
export const AddTimeDataStagetoMainHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/lms/addTimeDataStagetoMain`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            mode: params?.mode,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
export const GetBioMetricDataStageHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/lms/getBioMetricDataStage`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}
export const GetTimeDataStageHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/lms/getTimeDataStage`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Get Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Get update", hasError: false, data: err?.response?.data }
        })
}
export const GetAttendanceDataStageHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/lms/getAttendanceDataStage`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Get Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Get update", hasError: false, data: err?.response?.data }
        })
}
export const GetMonthlyWorkingDataStageHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/lms/getMonthlyWorkingDataStage`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Get Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Get update", hasError: false, data: err?.response?.data }
        })
}
export const AddMonthlyDaysStagetoMainHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/lms/addMonthlyWorkingDataStagetoMain`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
export const UpdateBioMetricDataStageHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/lms/updateBioMetricDataStage`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            stage_biometric_id: params?.stage_biometric_id,
            biometric_details: params?.biometric_details,
            mode: params?.mode
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}
export const DeleteBioMetricDataStageHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/deleteBioMetricDataStage`, {
        method: "DELETE",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            user_id: getUserId(),
            stage_biometric_id: params?.stage_biometric_id,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed to delete", hasError: false, data: err?.response?.data }
        })
}
export const UpdateTimeDataStageHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/lms/updateTimeDataStage`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            time_detail_stage_id: params?.time_detail_stage_id,
            time_details: params?.time_details,
            mode: params?.mode
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}
export const DeleteTimeDataStageHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/deleteTimeDataStage`, {
        method: "DELETE",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            user_id: getUserId(),
            time_detail_stage_id: params?.time_detail_stage_id,
            mode: params?.mode,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed to delete", hasError: false, data: err?.response?.data }
        })
}
export const GetBiometricPrefillHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/lms/getBiometricPrefill`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            month: params?.month,
            year: params?.year,
            ats_work_location_json: params?.ats_work_location_json || null,
            user_id: getUserId()
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}